<template>
  <div>
    <highcharts :options="options"></highcharts>
  </div>
</template>

<script>
// import moment from 'moment-timezone'

export default {
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    scale: {
      type: String
    },
    series: {
      type: Array
    },
    labels: {
      type: Array
    },
    stock: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    series () {
      this.options.series = this.series
    }
  },
  data () {
    return {
      options: {
        chart: {
          type: 'area',
          height: 300,
          zoomType: 'x'
        },
        title: {
          align: 'center',
          text: this.title,
          style: {
            color: '#333',
            fontSize: '16px',
            fontWeight: '400'
          }
        },
        subtitle: {
          text: '',
          style: {
            display: 'none'
          }
        },
        time: {
          timezone: 'America/New_York',
          useUTC: false
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                  showLastLabel: true,
                  endOnTick: true
                }
              }
            }
          }
        },
        xAxis: {
          type: 'datetime'
        },
        yAxis: {
          title: {
            text: this.scale
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        tooltip: {
          split: false,
          shared: true,
          hideDelay: 500,
          followPointer: true,
          shadow: true,
          animation: false,
          valueSuffix: '',
          pointFormat: '{series.name}: <b>{point.y:,.2f}</b><br/>'
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          borderWidth: 0
        },
        series: this.series,
        boost: {
          enabled: true
        }
      }
    }
  }
}
</script>

<style scoped></style>
